<!-- 
    左侧菜单
    lovi 2019-5-28
-->
<template>
  <div class="left-nav">
    <ul>
      <router-link
        v-for="(item, index) in navList"
        :key="index"
        :to="{ path: item.path }"
        exact-active-class="active"
        tag="li"
      >
        <i :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    navList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
  components: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.left-nav {
  margin-top: 20px;
  width: 250px;
  margin-right: 25px;
  ul li {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 56px;
    padding-left: 40px;
    color: #4a4a4a;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    i {
      margin-right: 10px;
      display: inline-block;
      width: 26px;
      height: 26px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 26px 26px;
      &.icon-single {
        background-image: url("~@/assets/images/menu/icon_single_nor.png");
      }
      &.icon-batch {
        background-image: url("~@/assets/images/menu/batch@2x.png");
      }
      &.icon-phone {
        background-image: url("~@/assets/images/menu/phone@2x.png");
      }
      &.icon-time {
        background-image: url("~@/assets/images/menu/icon_timing_nor.png");
      }
      &.icon-selfMotion {
        background-image: url("~@/assets/images/menu/selfMotion@2x.png");
      }
      &.icon-record-more {
        background-image: url("~@/assets/images/menu/record@2x.png");
      }
      // 资金管理
      &.icon-recharge {
        background-image: url("~@/assets/images/menu/wallet/icon_recharge_nor@2x.png");
      }
      &.icon-withdraw {
        background-image: url("~@/assets/images/menu/wallet/icon_withdraw_nor@2x.png");
      }
      &.icon-record {
        background-image: url("~@/assets/images/menu/wallet/icon_record_nor@2x.png");
      }
      &.icon-bankCard {
        background-image: url("~@/assets/images/menu/wallet/icon_bankCard_nor@2x.png");
      }
      // 个人中心
      &.icon-personal {
        background-image: url("~@/assets/images/menu/personal/icon_my_nor@2x.png");
      }
      &.icon-msgCenter {
        background-image: url("~@/assets/images/menu/personal/icon_message_nor@2x.png");
      }
      &.icon-bill {
        background-image: url("~@/assets/images/menu/personal/icon_record_nor@2x.png");
      }
    }
    &.active,
    &.active:hover {
      color: #fff;
      background: #2042ab;
      .icon-single {
        background-image: url("~@/assets/images/menu/icon_single.png");
      }
      .icon-batch {
        background-image: url("~@/assets/images/menu/batch_sel@2x.png");
      }
      .icon-phone {
        background-image: url("~@/assets/images/menu/phone_sel@2x.png");
      }
      .icon-time {
        background-image: url("~@/assets/images/menu/icon_timing.png");
      }
      .icon-selfMotion {
        background-image: url("~@/assets/images/menu/selfMotion_sel@2x.png");
      }
      .icon-record-more {
        background-image: url("~@/assets/images/menu/record_sel@2x.png");
      }
      // 资金管理
      .icon-recharge {
        background-image: url("~@/assets/images/menu/wallet/icon_recharge_sel@2x.png");
      }
      .icon-withdraw {
        background-image: url("~@/assets/images/menu/wallet/icon_withdraw_sel@2x.png");
      }
      .icon-record {
        background-image: url("~@/assets/images/menu/wallet/icon_record_sel@2x.png");
      }
      .icon-bankCard {
        background-image: url("~@/assets/images/menu/wallet/icon_bankCard_sel@2x.png");
      }
      // 个人中心
      .icon-personal {
        background-image: url("~@/assets/images/menu/personal/icon_my_sel@2x.png");
      }
      .icon-msgCenter {
        background-image: url("~@/assets/images/menu/personal/icon_message_sel@2x.png");
      }
      .icon-bill {
        background-image: url("~@/assets/images/menu/personal/icon_record_sel@2x.png");
      }
    }
    &:hover {
      color: #2042ab;
    }
  }
}
</style>
